import { handleRequest } from "../utilities/requestHandler";

export const getMachineModelFiles = (machineNumber) => 
    handleRequest("get", `/machines/models/${machineNumber}/files`);

export const uploadMachineModels = (formData, options = {}) => {
    const { headers: extraHeaders, ...rest } = options || {};
    return handleRequest("post", "/machines/upload", formData, {
        ...rest,
        headers: {
            "Content-Type": "multipart/form-data",
            ...(extraHeaders || {}),
        },
    });
};

export const deleteMachineModelFile = (machineNumber, fileKey) =>
    handleRequest("delete", `/machines/models/${machineNumber}/files/${fileKey}`);

export const replaceMachineModelFile = (machineNumber, fileKey, formData) =>
    handleRequest("post", `/machines/models/${machineNumber}/files/${fileKey}/replace`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
